module.exports = __webpack_public_path__ + "img/6.4d460d8a.jpg";